import React from 'react'

import { useEntityRootNavigation } from '../../../utils/routes/entityRoot'
import { useFormState } from '../../../packages/kiti/components/form/form/FormHandler'
import { useTemplate } from './_load/TemplateLoader'
import IconText from '../../../packages/kiti/components/presentation/IconText'
import Link from '../../../packages/kiti/components/actions/Link'
import LoadingWrapper from '../../../packages/kiti/components/helpers/LoadingWrapper'
import PageHeaderPanel from '../../../components/presentation/PageHeaderPanel'

const PageHeader = ({ loading }) => {
  const template = useTemplate()
  const navigatgeToHome = useEntityRootNavigation(template?.entity)

  const { handleSubmit, form } = useFormState()

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigatgeToHome()}
      title={template.name}
      mediumPadding
      noContainer
      side={
        <LoadingWrapper loading={loading} color="white">
          <Link block onClick={() => handleSubmit(form)}>
            <IconText
              iconSize="1.4rem"
              weight="700"
              iconLeft="RiCheckboxCircleLine"
              color="white"
              label={'Salvar'}
              noWrap
            />
          </Link>
        </LoadingWrapper>
      }
    />
  )
}

export default PageHeader
